

<div class="login-container m-auto">
  <div class="card boxshadow">
    <div class="card-header bg-primary text-white d-flex justify-content-center align-items-center">
      <a class="btn" style="border: 1px solid; border-color: white;"> Campaign Participation</a>

    </div>
    <div class="card-body">
      <div class="col-md-12">

        <div class="form-group">

          <div class="col-md-4">
            <label class="form-label">ICD Status</label>


            <ng-select [searchable]="true"
                       (change)="filterTableByStatus($event)">
              <ng-option *ngFor="let o of lstdata"
                         [value]="o">
                {{ o }}
              </ng-option>
            </ng-select>



          </div>




        </div>

        <table id="tbldata" datatable [dtOptions]="dtOptions" class="row-border hover">
        </table>

      </div>
    </div>
  </div>
</div>
